module.exports = __webpack_public_path__ + "img/ring_r_c_0_0@2x.64564a9b.png";